module.exports = __webpack_public_path__ + "static/media/dashboardOrder_en.e2ab150e.png";